import { DateTime } from 'luxon';

const DATETIME_FULL_CIFRA = { ...DateTime.DATETIME_FULL, timeZoneName: undefined };
const DATEPICKER_DATE_FORMAT = 'dd/MM/yyyy';
const DATEPICKER_DATETIME_FORMAT = 'dd/MM/yyyy hh:mm';

export function configuredTimeZone() {
  return document.querySelector('head meta[name=time-zone]').getAttribute('content');
}

function ensureDateTime(dateInicial) {
  let dateTime;
  if (dateInicial instanceof Date) {
    dateTime = DateTime.fromJSDate(dateInicial, { zone: configuredTimeZone() });
  } else {
    dateTime = DateTime.fromISO(dateInicial);
  }
  return dateTime;
}

// Objeto date de javascript a formato que es entendible por el datepicker
export function dateToDatepicker(date) {
  // De momento forzamos es-ES porque el datepicker no está preparado para otro formato, cuando se
  // adapte el datepicker podemos adaptar también este método
  return ensureDateTime(date).toFormat(DATEPICKER_DATE_FORMAT);
}

// Tienen que indicar un objeto date o un string con la fecha en formato ISO
export function dateToLocaleDateString(date) {
  return ensureDateTime(date).toLocaleString(DateTime.DATE_SHORT);
}

export function dateToTimeString(date) {
  return ensureDateTime(date).toLocaleString(DateTime.TIME_24_SIMPLE);
}

export function dateToDateTimeString(date, options = {}) {
  const format = options.completa ? DATETIME_FULL_CIFRA : DateTime.DATETIME_SHORT;
  return ensureDateTime(date).toLocaleString(format);
}

// Pasa una fecha en el formato del datepicker (español) a un Date de js
export function datepickerToDate(date) {
  // Si tiene espacio suponemos que será fecha y hora 25/12/2024 13:30
  let format = DATEPICKER_DATE_FORMAT;
  if (date.includes(' ')) {
    format = DATEPICKER_DATETIME_FORMAT;
  }
  return DateTime.fromFormat(date, format).toJSDate();
}

// Ej javascritp se puede construir un objeto date con datos incorrecto (Invalid Date),
// este método comprueba que la fecha sea correcta
export function isValidDate(date) {
  // NO se puede cambiar por Number.isNan, hacen cosas diferentes
  // eslint-disable-next-line no-restricted-globals
  return date instanceof Date && !isNaN(date);
}

// Son dos objetos Date que el primero contendrá la fecha y el segundo la hora.
// Este método devuelve un Date con los datos mezclados
export function joinDateTime(date, time) {
  return new Date(
    // eslint-disable-next-line max-len
    date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds(),
  );
}

// Fecha en formato ISO sin hora ni nada (2022-10-12)
export function onlyISODate(dateInicial) {
  return ensureDateTime(dateInicial).toISODate();
}

// Si tenemos una fecha javascript tal que 2023-09-04 00:00 introducida en el navegador,
// está en el timezone actual (GMT +2). Al convertirla a formato ISO para mandarla al servidor
// con toISOString() nos devuelve 2023-09-03T23:00:00Z. Realmente es el mismo instante pero es muy
// confuso y Rails lo interpreta mal.
// Esta función lo que hace es devolvernos la hora inicial sin indicar que es UTC por lo que
// se entiende que esa hora es en el timezone del usuario: 2023-09-04T00:00
export function localISODateTimeString(date) {
  if (!date) {
    return '';
  }
  const tzoffset = date.getTimezoneOffset() * 60000;
  return (new Date(date.getTime() - tzoffset)).toISOString().slice(0, -1);
}

// Time sería 12:15
export function timeStringToDate(time) {
  return ensureDateTime(time).toJSDate();
}
